/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_ReservationsInputs */

const en_nav_reservations = /** @type {(inputs: Nav_ReservationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reservations`)
};

const es_nav_reservations = /** @type {(inputs: Nav_ReservationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reservas`)
};

/**
* | output |
* | --- |
* | "Reservations" |
*
* @param {Nav_ReservationsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const nav_reservations = /** @type {((inputs?: Nav_ReservationsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_ReservationsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_reservations(inputs)
	return es_nav_reservations(inputs)
});